module.exports = __webpack_public_path__ + "assets/imgs/logos/sephora.7caa246f3c558567e80848ff02255282.svg";